import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

// Palette contains in each row the maximum altitude, R,G,B color, and legend text

/*
# QGIS Generated Color Map Export File
INTERPOLATION:DISCRETE
0,255,245,241,0,<= 0,0000
2,246,161,255,255,0,0000 - 2,0000
5,23,81,255,255,2,0000 - 5,0000
10,83,126,255,255,5,0000 - 10,0000
20,10,243,255,255,10,0000 - 20,0000
50,2,255,23,255,20,0000 - 50,0000
100,185,254,75,255,50,0000 - 100,0000
200,241,253,79,255,100,0000 - 200,0000
500,240,184,79,255,200,0000 - 500,0000
1000,243,92,22,255,500,0000 - 1000,0000
2000,228,89,92,255,1000,0000 - 2000,0000
5000,188,5,63,255,2000,0000 - 5000,0000
inf,17,0,4,255,> 5000,0000
*/

const palette = [
  [-1, 180, 180, 180, 255, "N/A"],
  [0, 255, 255, 255, 255, "0"],
  [2, 246, 161, 255, 255, "0.0 - 2.0"],
  [5, 23, 81, 255, 255, "2.0 - 5.0"],
  [10, 83, 126, 255, 255, "5.0 - 10.0"],
  [20, 10, 243, 255, 255, "10.0 - 20.0"],
  [50, 2, 255, 23, 255, "20.0 - 50.0"],
  [100, 185, 254, 75, 255, "50.0 - 100.0"],
  [200, 241, 253, 79, 255, "100.0 - 200.0"],
  [500, 240, 184, 79, 255, "200.0 - 500.0"],
  [1000, 243, 92, 22, 255, "500.0 - 1000.0"],
  [2000, 228, 89, 92, 255, "1000.0 - 2000.0"],
  [5000, 188, 5, 63, 255, "2000.0 - 5000.0"],
  [Infinity, 17, 0, 4, 255, "> 5000.0"],
];

export const populationDensityEurLegendColorList = palette.map(
  ([_val, r, g, b, _a, _txt]) => `rgb(${r}, ${g}, ${b})`,
);

export const PopulationDensityEurLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{t("legend.populationDensityEur")}</b>
      </div>

      {palette.map(([value, r, g, b, a, label]) => (
        <div key={value}>
          <span style={legendItemStyle(`rgba(${r}, ${g}, ${b}, ${a / 255})`)}></span>
          {label}
        </div>
      ))}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {t("riskExposureMapExplained.populationDensityEur")}
        </span>
      </div>
    </div>
  );
};
